var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagNl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A2001D",
  d: "M16 0C9.12 0 3.256 4.342.995 10.435h30.01C28.745 4.342 22.879 0 16 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052B4",
  d: "M16 32c6.88 0 12.744-4.342 15.005-10.435H.995C3.255 27.658 9.12 32 16 32"
})));
export default SvgFlagNl;